<template>
  <div>
    <list
      row-key="ArticleId"
      ref="list"
      unit="信息通告"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="开始日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            size="mini"
            @change="endChange"
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="标题">
          <el-input size="mini" v-model="params.Title" clearable placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-select size="mini" v-model="params.IsTop" clearable placeholder="请选择是否置顶">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Title" label="标题" min-width="140px" />
        <!-- <el-table-column prop="AddTime" label="提交时间" min-width="140px"/> -->
        <el-table-column prop="Publisher" label="发布人"/>
        <el-table-column prop="PublishTime" label="发布时间" min-width="100px">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.PublishTime)}}
          </template>
        </el-table-column>
        <el-table-column prop="Source" label="信息来源" />
        <el-table-column prop="ClickCount" label="点击率" />
        <el-table-column prop="IsTop" label="是否置顶" width="80" align="center">
          <template slot-scope="{row}">
            <span>{{row.IsTop?'是':'否'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StatusText" label="状态" align="center" width="90">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.StatusText=='发布'">发布</el-tag>
            <el-tag type="primary" v-else-if="row.StatusText=='草稿'">草稿</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/web/article").default,
      params: {
        Title: "",
        // ColumnId: 1,
        StartTime: null,
        EndTime: null,
        IsTop: null,
      },
    };
  },
  methods: {
    endChange(t) {
      console.log("t",t)
      if(t) {
        this.params.EndTime += " 23:59:59";
      }
    },
    delRange(ids) {
      console.log(ids);
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>